declare var angular: any;
import * as _ from 'underscore';

angular.module('LexiconControllers')

  .service('lexicon', ['$http', '$mdToast', '$mdBottomSheet', 'api', function($http, $mdToast, $mdBottomSheet, api) {

    this.addWord = function(text) {
      return api.addWord(text).then(function (data) {
        $mdToast.show($mdToast.simple()
          .textContent("Le mot a bien été ajouté à votre glossaire")
          .position('bottom right'));
        return data;
      });
    };

    this.getWord = function(text, callback) {
      return api.sync(api.getWord, callback, text);

    };

    this.removeWord = function(text) {
      return api.removeWord(text).then(function(data) {
        $mdToast.show($mdToast.simple()
          .textContent('Le mot a bien été supprimé de votre glossaire')
          .position('bottom right'));
      }, function (error) {
        $mdToast.show($mdToast.simple()
          .textContent('Une erreur est survenue')
          .position('bottom right'));
      });
    };

    var self = this;

    this.showWordBottom = function(word) {
      ShowLexiconController.$inject = ["$scope", "word"];
      $mdBottomSheet.show({
        disableParentScroll: true,
        controller: ShowLexiconController,
        locals: {
          word: word,
        },
        templateUrl: '/ng1/www/modules/lexicon/html/lexicon_bottom.html',
      });

      function ShowLexiconController($scope, word) {
        $scope.addWord = function () {
          $scope.is_in = true;
          return self.addWord($scope.data.text).catch(function (data) {
            $scope.is_in = false;
          });
        }

        $scope.removeWord = function () {
          $scope.is_in = false;
          return self.removeWord($scope.data.text).catch(function () {
            $scope.is_in = true;
          });
        }

        self.getWord(word, function (data) {
          $scope.data = data;
          $scope.data.quotes = _.filter($scope.data.quotes, (quote: any) => quote.text.length < 300);
        }).catch(function () {
          $mdBottomSheet.cancel();
          $mdToast.show($mdToast.simple()
            .textContent("Le mot est inconnu de notre dictionnaire")
            .position('bottom right'));
        });

        api.sync(api.getWords, function (data) {
          $scope.is_in = _.contains(_.map(data, (word: any) => word.text), word);
        });
      };
    };
  }
  ]);
